interface PlayerDemoProps {
  cover: string;
  title: string;
  episodeLabel: string;
  quality: string;
  subtitle: string;
}

export default function PlayerDemo({ cover, title, episodeLabel, quality, subtitle }: PlayerDemoProps) {
  return (
    <div className="rounded-lg overflow-hidden border border-background-200 bg-primary-950">
      <div className="relative w-full aspect-video">
        <img
          src={cover}
          alt={`${title}播放器演示封面`}
          title={`${title} - 中文字幕在线观看`}
          className="absolute inset-0 w-full h-full object-cover object-top opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-primary-950 via-primary-950/70 to-primary-950/40"></div>
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
          <span className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-accent-500 text-background-50 flex items-center justify-center mb-4">
            <i className="ri-play-fill text-3xl md:text-4xl"></i>
          </span>
          <p className="text-background-50 text-lg md:text-2xl font-heading font-bold">{title}</p>
          <p className="mt-2 text-sm text-accent-200">{episodeLabel}</p>
          <p className="mt-3 inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs md:text-sm bg-background-50/10 text-background-200 border border-background-50/20">
            <i className="ri-information-line"></i>
            演示播放器区域 · 视频内容即将上线，暂不支持真实播放
          </p>
        </div>
        <div className="absolute top-3 left-3 flex items-center gap-2">
          <span className="px-2 py-0.5 rounded-md text-xs bg-background-50/90 text-primary-800 font-medium whitespace-nowrap">{quality}</span>
          <span className="px-2 py-0.5 rounded-md text-xs bg-secondary-500/90 text-background-50 whitespace-nowrap">{subtitle}</span>
        </div>
      </div>
      <div className="flex items-center gap-3 px-4 py-3 bg-primary-900 text-primary-100 text-xs md:text-sm">
        <span className="flex items-center gap-1"><i className="ri-live-line text-accent-400"></i>线路 1 · 高清</span>
        <span className="flex items-center gap-1"><i className="ri-translate-2"></i>中文字幕</span>
        <span className="ml-auto hidden sm:block">本站为前端演示，播放器不产生真实播放行为</span>
      </div>
    </div>
  );
}